<template>
  <div>
    <ul
      :class="s.plan_list"
      v-if="planLoaded">
      <li :class="s.plan"
        v-for="(plan, planName) in courseData"
        :key="planName">
        <input
          type="radio"
          style="display: none;"
          :id="planName"
          :name="planName"
          v-model="selected"
          :value="planName"
          :checked="planName === selected">
        <label
          :for="planName"
          :class="[
            planName === selected ? s.selected : '',
            s.label
          ]">
          <p
            v-if="helper.master?.products"
            :class="s.label_title">{{ helper.master.products.plans[planName].label }}</p>
          <Spacer :y="4"/>
          <div :class="s.assistant">
            <p
              v-for="des in helper.master.products.plans[planName].description"
              :key="des"
              :class="s.label_des"><i class="fa-regular fa-badge-check"/>{{ des }}</p>
          </div>
          <Spacer :y="4"/>
          <div :class="s.price_wrap">
            <div :class="s.price">
              <div
                v-if="helper.master?.products"
                :class="s.default">&yen;{{ addComma(plan.unit_amount) }}/{{ helper.master.products.plans[planName].term }}</div>
            </div>
          </div>
          <Spacer :y="4"/>
        </label>
      </li>
    </ul>
    <Loading v-else/>
    <Spacer :y="3"/>
    <ul :class="s.warn">
      <li v-if="user.statusFlags.isPaid">電子版+紙面配達プランに変更する場合は、次回請求より¥2,400が請求され、差額は請求されません。ただし、紙面は翌日以降配達されます。</li>
      <li v-if="user.statusFlags.isPaid">電子版+紙面配達プランから電子版プランへ変更しても差額は返金されません。</li>
      <li v-if="!user.statusFlags.isPaid">※クレジットカード決済は、「前払い（前納）」で１カ月単位の購読となります。原則として月途中の解約はできませんのでご了承ください。</li>
    </ul>

    <!-- 紙面配達を含むプランの場合には住所を登録 -->
    <div
      v-if="['webPaper', 'paper'].includes(selected) && user.statusFlags.isPaid"
      :class="s.address">
      <div v-if="!deliveryAddress || flag.edit">
        <p>配達先を設定してください。</p>
        <Address
          :type="2"
          :showDeleteBtn="false"
          :showRegistBtn="true"
          @isCancel="flag.edit = false"
          @updated="flag.edit = false"/>
      </div>
      <div v-else>
        <p><i class="fa-solid fa-house me-2"/>配送先</p>
        <Spacer :y="2"/>
        <div class="d-flex justify-content-between align-items-center">
          <p class="flex-1">{{ deliveryAddress.label }}</p>
          <button :class="s.edit" @click="flag.edit = true">変更する</button>
        </div>
      </div>
    </div>

    <!-- 確定ボタン -->
    <div :class="[styleClasses.btns, s.btns]">
      <button
        v-if="!user.statusFlags.isUnderContract"
        :class="[styleClasses.btn, styleClasses.primary]"
        :disabled="!selectedCourse"
        @click="toNext()">次に進む</button>
      <button
        v-if="user.statusFlags.isUnderContract"
        :class="[styleClasses.btn, styleClasses.primary]"
        :disabled="validPlan === selectedCourse || !readySubmitChange"
        @click="changePlan()">プランを変更する</button>
    </div>
    <div :class="[styleClasses.btns, s.btns, s.column]">
      <div
        v-if="$route.query.plan"
        :class="s.notNow"
        @click="notNow">とりあえず２週間のトライアル（無料）にする</div>
      <div v-if="$route.query.plan" :class="s.note">
        ※トライアル（無料）の場合、会員登録から２週間は無料で電子版をお楽しみいただけます。無料期間終了前に有料会員お申し込みのリマインドメールを送信させていただきます。
      </div>
      <div
        v-if="user.statusFlags.isUnderContract"
        :class="s.cancel"
        @click="cancelSubscription">解約する</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import cf from '@/mixins/commonFunctions.js';
import Spacer from '@/components/Spacer';
import Loading from '@/components/Loading.vue';
import Address from '@/components/parts/Address.vue';

export default {
  name: 'edit-subscription-plan',
  mixins: [cf],
  components: {
    Spacer,
    Loading,
    Address,
  },
  props: {
    selectedCourse: String || null,
    customerDefaultSource: Object || null,
    deliveryAddress: Object || null,
    styleClasses: Object,
    courseData: Object || null,
    planLoaded: Boolean,
  },
  data() {
    return {
      flag: {
        planLoaded: false,
      },
      selected: null,
    };
  },
  created() {
    this.selected = this.selectedCourse;
  },
  mounted() {
    const query = this.$route.query;
    if (query.plan) this.selected = query.plan;
  },
  computed: {
    ...mapState(['user', 'helper']),
    validPlan() {
      return null;
      // const nicknames = Object.keys(this.plans || {});
      // const plan = nicknames.find((key) => this.plans[key].id === this.user.customer.subscriptions[0]?.price_id);
      // return plan ? this.plans[plan].nickname : null;
    },
    readySubmitChange() {
      return this.selected && (!this.selected.toLowerCase().includes('paper') || this.deliveryAddress) && this.selected !== this.user.customer?.subscriptions[0]?.planName;
    },
  },
  watch: {
    selected() {
      this.$emit('changeCourse', this.selected);
    },
  },
  methods: {
    toNext() {
      this.$emit('setPlan', this.selected);
      this.$router.push('/edit/subscription/cancel-exists/');
    },

    notNow() {
      if (!confirm('定期購読のお申込みが完了しておりません。\n無料期間終了後に有料記事が読めなくなります。\nこのページを離れてよろしいですか？')) return;
      this.$router.push('/');
    },

    changeCourses() {
      if (!confirm('プランを変更します。よろしいですか？\n※この操作は取り消せません。')) return;
      this.$emit('handleLoading', 'show');
      this.flag.planLoaded = true;

      const data = {
        id: this.user.customer.subscriptions[0].id, // StripeSubscriptionsのID
        user_id: this.user.id,
        email: this.user.email,
        customer_id: this.user.customer.customer_id,
        subscription_id: this.user.customer.subscriptions[0].subscription_id,
        price_id: this.courseData[this.selected].id,
      };

      this.axios({
        method: 'POST',
        url: '/v1/stripe/subscription/set/update',
        data,
      })
        .then((response) => {
          const res = response.data;
          if (res.updateStripe && res.updateDB) {
            alert('定期購読のプラン変更が完了しました。');
            this.$store.dispatch('user/update');
          } else {
            alert('プラン更新中に何らかのエラーが発生しました。\nもう一度お試しいただくか、サイト管理者へお問合せください。');
          }
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        })
        .finally(() => {
          this.$emit('handleLoading', 'hide');
          this.flag.planLoaded = false;
          this.flag.courseChanged = true;
        });
    },
    cancelSubscription() {
      if (!confirm('定期購読をキャンセルします。よろしいですか？\n※この操作は取り消せません。')) return;
      this.$emit('handleLoading', 'show');
      this.flag.planLoaded = true;

      const data = {
        id: this.user.customer.subscriptions[0].id, // StripeSubscriptionsのID
        user_id: this.user.id,
        email: this.user.email,
        customer_id: this.user.customer.customer_id,
        subscription_id: this.user.customer.subscriptions[0].subscription_id,
      };

      const expire = moment(this.user.customer.subscriptions[0].expire).format('YYYY年MM月DD日');
      const priceDetail = Object.keys(this.courseData || {}).find((row) => this.courseData[row].id === this.user.customer.subscriptions[0].price_id);
      const expirePlanLabel = {
        webPaper: '有料会員としてウェブ電子版をご利用が可能であり、紙面の配達もございます。',
        web: '有料会員としてウェブ電子版をご利用が可能です。',
        paper: '紙面の配達もございます。',
      };

      this.axios({
        method: 'POST',
        url: '/v1/stripe/subscription/set/cancel',
        data,
      })
        .then(() => {
          alert(`定期購読の解約処理が完了しました。\nなお、${expire}までは${expirePlanLabel[priceDetail]}`);
          this.$store.dispatch('user/update');
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        })
        .finally(() => {
          this.$emit('handleLoading', 'hide');
          this.flag.planLoaded = false;
          this.flag.canceled = true;
        });
    },

    changePlan() {
      if (!confirm('プランを変更します。よろしいですか？\n※この操作は取り消せません。')) return;
      this.$emit('handleLoading', 'show');

      const data = {
        id: this.user.customer.subscriptions[0].id, // StripeSubscriptionsのID
        user_id: this.user.id,
        email: this.user.email,
        customer_id: this.user.customer.customer_id,
        subscription_id: this.user.customer.subscriptions[0].subscription_id,
        price_id: this.courseData[this.selected].id,
      };

      this.axios({
        method: 'POST',
        url: '/v1/stripe/subscription/set/update',
        data,
      })
        .then((response) => {
          const res = response.data;
          if (res.updateStripe && res.updateDB) {
            alert('定期購読のプラン変更が完了しました。');
            this.$store.dispatch('user/update');
          } else {
            alert('プラン更新中に何らかのエラーが発生しました。\nもう一度お試しいただくか、サイト管理者へお問合せください。');
          }
        })
        .catch((error) => {
          alert('処理中にエラーが発生しました。\nもう一度お試しいただくか、サイト管理者へお問合せください。');
          if (error.response) console.log(error.response.data);
          else console.log(error);
        })
        .finally(() => {
          this.$emit('handleLoading', 'hide');
        });
    },
  },
};
</script>

<style lang="scss" module="s">
.plan_list {
  li {
    margin-bottom: 32px;
  }
}
.warn {
  color: var(--red);
  li {
    padding-left: 16px;
    position: relative;
    &::before {
      content: '※';
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}
.label {
  outline: 1px solid #858585;
  border-radius: 4px;
  width: 100%;
  color: var(--gray);

  // default
  outline-color: var(--black);
  border-width: 1.5px;
  color: var(--black);

  &_title {
    padding: 15px 32px;
    background-color: var(--black);
    color: #fff;
    text-align: center;
    font-size: 22px;
  }

  .assistant {
    padding: 0 32px;
    font-size: 12px;
    display: flex;
    flex-flow: column;
    align-items: center;

    i {
      font-size: 16px;
      color: green;
      margin-right: 4px;
    }
  }

  &_current {
    font-size: 12px;
    color: var(--gray);
  }

  &.selected {
    outline-color: var(--red);
    outline-width: 3px;
    // color: var(--red);

    .label_title {
      // background-color: var(--red);
    }
  }
  .price {
    display: flex;
    align-items: center;
    &_wrap {
      display: flex;
      justify-content: center;
    }
    @include xs-view {
      flex-flow: column;
    }
  }

  .default {
    font-size: 24px;
    &.notDefault {
      position: relative;
      &::after {
        content: '';
        width: 100%;
        height: 2px;
        background-color: var(--font-black);
        position: absolute;
        top: 50%;
        left: 0;
      }
    }
  }

  .arrow {
    margin-left: 26px;
    font-size: 24px;
    &.right {
      @include xs-view {
        display: none;
      }
    }
    &.down {
      margin-left: 0;
      display: none;
      @include xs-view {
        display: inline-block;
      }
    }
  }

  .trial {
    margin-left: 16px;
    display: flex;
    flex-flow: column;
    align-items: center;
    &_assistant {
      font-size: 14px;
    }
    &_price {
      font-size: 26px;
      .zero {
        font-size: 37px;
        line-height: 1;
      }
    }
    &_des {
      font-size: 12px;
    }
    @include xs-view {
      margin-left: 0;
      margin-top: 12px;
    }
  }
}
.btns {
  margin-top: 24px;
  &.column {
    flex-direction: column;
    align-items: center;
  }
}
.notNow {
  font-size: 12px;
  color: var(--gray);
  text-decoration: underline;
  cursor: pointer;
}
.cancel {
  margin: 12px 0 0 0 !important;
  display: inline-block;
  text-decoration: underline;
  color: var(--black);
  cursor: pointer;
}
.edit {
  text-decoration: underline;
  color: var(--black);
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
  border: none;
  background-color: transparent;
  padding: 0;
  font-size: 12px;
  white-space: nowrap;
  margin-left: 12px;
}
.address {
  margin-top: 32px;
  padding: 18px 24px;
  border: 1px solid var(--border-gray);
  border-radius: 6px;
}
.note {
  font-size: 12px;
  color: var(--font-gray);
  margin-top: 8px;
}
</style>
